import { render } from "./PromptElement.vue?vue&type=template&id=20527ae9&scoped=true&ts=true"
import script from "./PromptElement.vue?vue&type=script&lang=ts"
export * from "./PromptElement.vue?vue&type=script&lang=ts"

import "./PromptElement.vue?vue&type=style&index=0&id=20527ae9&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20527ae9"]])

export default __exports__